

  
const content = `# SecureAI Agent Automation
  
SecureAI offers agentic AI automation features out of the box and enables users to create AI agents for workflow automation. An agent can be easily created with a natural language 
prompt to automate any number of tasks. It can interact with various type of resources, such as files, databases, cloud storage, emails, and any kind of APIs, to process data and 
automate workflows.  
  
SecureAI provides a number of tools that can be configured to meet your automation needs. An administrative user may configure such tools and assign them, together with tool 
configurations, to user roles. Such roles can then be assigned to users and user groups. To create an agent, a user just need to select a pre-configured GenAI LLM, provide a detail 
prompt, and select the necessary tools and tool configurations for GenAI LLM to use. An agent can be tested, then published and scheduled to run automatically.  
  
Please note that SecureAI automatically enforces the data security policy configured for each GenAI LLM. If sensitive data should not be revealed to a GenAI LLM, SecureAI will used 
a proprietary solution to interact with GenAI LLM, so that GenAI LLM can perform data processing and automate workflows without accessing the actual sensitive data.  
  
When an agent generates outputs or performs certain tasks, the data access roles assigned to you will determine whether the sensitive data will be revealed to you or whether certain 
data operations (such as insert, update or delete) are allowed for such data. Please check with your system administrator if you need access to certain types of sensitive, 
confidential, or regulated data.  
  
  `
  
export default content;
